<style lang="less" scoped>
@import '@/style/index.less';
.collection-list{
  width: 100%;
}
</style>

<template>
  <div class="collection-list" >
    <ListView ref="list-view" :complex-list="mainData" :option="listOption" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { ComplexList } from 'complex-data'
import ListView from '@/components/data/ListView'
import { listWidth } from '@/config/dictionary/config'
import vehicleApi from '@/pages/index/api/vehicle'
import user from '@/data/user'
import { cascader } from '@/pages/index/select/cascader'
import option from '@/style/option'

export class CostDetail extends ComplexList {
  buildItem(postData: Record<string, unknown>) {
    return new Promise((resolve) => {
      const targetValue = this.$createDataByDictionary(postData)
      this.$list.push(targetValue)
      this.syncData()
      resolve({ status: 'success' })
    })
  }
  deleteItem(postData: Record<string, unknown>) {
    return new Promise((resolve) => {
      const index = this.$list.indexOf(postData)
      if (index > -1) {
        this.$list.splice(index, 1)
      }
      resolve({ status: 'success' })
    })
  }
  syncData() {
    const vue = this.$getExtra('vue')
    vue.$emit('change', [...this.$list])
  }
}

export default defineComponent({
  name: 'CostDetail',
  components: {
    ListView
  },
  props: {
    id: {
      type: String
    },
    value: {
      required: true
    },
    disabled: {
      required: true
    }
  },
  data() {
    const mainData = new CostDetail({
      name: '费用明细',
      prop: 'costDetail',
      module: {
        dictionary: {
          layout: {
            default: {
              grid: 12,
              label: 8,
              content: 16
            }
          },
          option: {},
          propData: {
            id: 'id'
          },
          list: [
            {
              prop: 'id',
              name: 'ID',
              originProp: 'id',
              originFrom: 'list',
              mod: {}
            },
            {
              prop: 'applyRecordId',
              name: 'applyRecordId',
              originProp: 'applyRecordId',
              originFrom: 'list',
              mod: {}
            },
            {
              prop: 'costSubject',
              name: '费用科目',
              originProp: 'costSubject',
              originFrom: 'list',
              show(value) {
                return cascader.APPLY_KEEP_COST_Subject.getItem(value).label
              },
              post(value, payload) {
                payload.targetData!.costType = (value as string[])[1]
                return (value as string[])[0]
              },
              mod: {
                list: {},
                edit: {
                  type: 'cascader',
                  option: {
                    list: cascader.APPLY_KEEP_COST_Subject.getList()
                  },
                  required: true
                },
                build: {
                  $target: 'edit'
                },
                change: {
                  $target: 'edit'
                }
              }
            },
            {
              prop: 'costType',
              name: '费用类型',
              originProp: 'costType',
              originFrom: 'list',
              show(value, payload) {
                const item = cascader.APPLY_KEEP_COST_Subject.getCascadeList([payload.targetData!.costSubject, value as string])[1]
                return item?.label
              },
              mod: {
                list: {}
              }
            },
            {
              prop: 'cost',
              name: '金额',
              originProp: 'cost',
              originFrom: 'list',
              mod: {
                list: {
                  width: listWidth.getWidth(5)
                },
                edit: {
                  type: 'inputNumber',
                  option: {
                    min: 0,
                    precision: 2
                  },
                  required: true
                },
                build: {
                  $target: 'edit'
                },
                change: {
                  $target: 'edit'
                }
              }
            },
            {
              prop: 'collectionPersonName',
              name: '催收人员',
              originProp: 'collectionPersonName',
              originFrom: 'list',
              mod: {
                list: {
                  width: listWidth.personnelName
                },
                edit: {
                  type: 'input',
                  disabled: true,
                  required: true,
                  value: {
                    default: user.info.name
                  }
                },
                build: {
                  $target: 'edit'
                },
                change: {
                  $target: 'edit'
                }
              }
            },
            {
              prop: 'description',
              name: '说明',
              originProp: 'description',
              originFrom: 'list',
              mod: {
                list: {},
                edit: {
                  type: 'textArea',
                  required: true
                },
                build: {
                  $target: 'edit'
                },
                change: {
                  $target: 'edit'
                }
              }
            },
            {
              prop: 'remark',
              name: '备注',
              originProp: 'remark',
              originFrom: 'list',
              mod: {}
            },
            {
              prop: 'createdBy',
              name: '创建人',
              originProp: 'createdBy',
              originFrom: 'list',
              mod: {}
            },
            {
              prop: 'createdTime',
              name: '创建时间',
              originProp: 'createdTime',
              originFrom: 'list',
              mod: {
                list: {
                  width: listWidth.time
                }
              }
            },
            {
              prop: 'updatedBy',
              name: '更新人',
              originProp: 'updatedBy',
              originFrom: 'list',
              mod: {}
            },
            {
              prop: 'updatedTime',
              name: '更新时间',
              originProp: 'updatedTime',
              originFrom: 'list',
              mod: {}
            },
            {
              prop: 'menu',
              name: '操作',
              originProp: 'menu',
              originFrom: 'local',
              mod: {
                list: {
                  width: 120
                }
              }
            },
          ]
        },
        search: {
          module: {
            dictionary: {}
          },
          menu: {
            list: [
              {
                name: '新增',
                prop: 'build',
                type: 'primary',
              }
            ]
          }
        }
      },
      $getData(this: CostDetail) {
        return new Promise((resolve, reject) => {
          vehicleApi.vehiclePreservationCostDetail.require({
            applyRecordKeepId: this.$getDictionaryPropData('data', 'parentId')
          }).then(res => {
            this.$formatList(res.data.data)
            this.syncData()
            resolve({ status: 'success' })
          }).catch(err => {
            // eslint-disable-next-line no-console
            console.error(err)
            reject(err)
          })
        })
      }
    })
    return {
      mainData: mainData
    }
  },
  computed: {
    listOption() {
      return {
        table: {
          optionProps: {
            bordered: true
          }
        },
        menu: {
          list: this.disabled ? [] : [
            {
              prop: 'delete',
              name: '删除',
              option: {
                style: {
                  color: option.color.danger
                }
              }
            }
          ]
        },
        search: this.disabled ? false : {},
        edit: {
          modal: {
            optionProps: {
              width: 960
            }
          }
        }
      }
    }
  },
  watch: {
    id: {
      immediate: true,
      handler(value) {
        if (value) {
          this.mainData.$setDictionaryPropData(this.id, 'data', 'parentId')
          this.mainData.$loadData(true)
        }
      }
    }
  },
  mounted() {
    this.mainData.$setExtra('vue', this)
  },
  beforeUnmount() {
    this.mainData.$setExtra('vue', null)
    this.mainData.$reset()
  },
  methods: {}
})
</script>
